import styles from "./buttons.module.css";

export const ImageLink = ({ imageSrc, altText = "Link", handleClick }) => {
	return (
		<button className={`${styles.ImageLink} btn icon`} onClick={handleClick}>
			<img src={imageSrc} alt={altText} className={styles.imgLink} />
		</button>
	);
};
